import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { selectNeedsPushPermission } from 'selectors/webPush'
import { doUpdateAudioNotificationsFromUI } from 'ducks/chat/actions/notifications'
import { selectIsMatrixClientReady } from 'ducks/chat/selectors/client'
import { styles as notificationStyles } from './styles'

const NotificationsPermissions = () => {
  const clientReady = useSelector(selectIsMatrixClientReady)
  const needsPushPermission = useSelector(selectNeedsPushPermission)
  const dispatch = useDispatch()
  const onEnable = useCallback(
    () => {
      dispatch(doUpdateAudioNotificationsFromUI(true))
    },
    [dispatch]
  )

  if (!clientReady || !needsPushPermission) return null
  return (
    <div css={notificationStyles.notificationCard}>
      <div css={notificationStyles.notificationHeading}>
        Enable notifications
      </div>
      <p className="grui mt-0 mb-5">
        Never miss a message with notifications enabled.
      </p>
      <Button
        type="info"
        size="small"
        onClick={onEnable}
        css={notificationStyles.btn}
      >
        Enable notifications
      </Button>
    </div>
  )
}

export default NotificationsPermissions
